<template>
  <div id="app">
    <header class="c-header">
      <div class="c-header__inner l-columns-container l-columns-container--outmost">
        <router-link
          id="home-link"
          class="c-logo"
          to="/"
        >
          <svg
            id="header-logo"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="30 30 800 160"
            enable-background="new 0 0 800 160"
            xml:space="preserve"
          >
            <path
              class="logo-letter"
              d="M262.3,172.1V39.9h31.8v102.4h30.2v29.8H262.3z"
            />
            <path
              class="logo-letter"
              d="M334.2,172.1v-29.8h10.1c6.7,0,8-4.8,8-9.2V39.9h31.9v97.4c0,20.8-6.7,34.8-34.8,34.8H334.2z"
            />
            <path
              class="logo-letter"
              d="M404.6,172.1V39.9h63.3v29.8h-31.3v20.4h29.8v29.4h-29.8v22.7h31.3v29.8H404.6z"
            />
            <path
              class="logo-letter"
              d="M531.8,69.7v102.4h-31.9V69.7h-22.1V39.9h76.1v29.8H531.8z"
            />
            <path
              class="logo-letter"
              d="M624.2,37.4c43.2,0,70.1,29.6,70.1,68.2c0,38.6-26.7,69-69.1,69c-43.2,0-69.6-29.6-69.6-68.4
              C555.5,67.8,583.4,37.4,624.2,37.4z M624.9,144.8c23.4,0,36-17.2,36-38.8s-13.4-38.8-36.2-38.8c-23.3,0-35.7,17.2-35.7,38.8
              C589,127.8,602.9,144.8,624.9,144.8z"
            />
            <path
              class="logo-letter"
              d="M174.5,37.4c43.2,0,70.1,29.6,70.1,68.2c0,38.6-26.7,69-69.1,69c-43.2,0-69.6-29.6-69.6-68.4
              C105.9,67.8,133.7,37.4,174.5,37.4z M175.2,144.8c23.4,0,36-17.2,36-38.8S197.8,67.2,175,67.2c-23.3,0-35.7,17.2-35.7,38.8
              C139.3,127.8,153.2,144.8,175.2,144.8z"
            />
            <path
              class="logo-letter"
              d="M741.6,94v78.1h-30.7V39.9h32.8l49.7,79.9V39.9h30.8v132.2h-31.6L741.6,94z"
            />
            <path
              class="logo-letter"
              d="M63.9,119.6v52.5H31.9V39.9h63.4v29.8H63.9v20.4h30.6v29.4H63.9z"
            />
            <polygon
              fill="#1E46FF"
              points="114.4,185.8 95.5,166.9 236.1,26.2 255.1,45.1 "
            />
          </svg>
        </router-link>

        <!-- <div class="c-header__right"> -->
        <Navigation
          :class="{ open: menuOpen }"
        />
        <button
          id="menu-opener"
          class="c-hamburger"
          :class="{ open: menuOpen }"
          @click="toggleMenu()"
        >
          <div
            ref="hamburgerLineOne"
            class="c-hamburger__line c-hamburger__line--one"
          />
          <div
            ref="hamburgerLineTwo"
            class="c-hamburger__line c-hamburger__line--two"
          />
        </button>
        <!-- </div> -->
      </div>
    </header>

    <Dev />
    <router-view class="router-view" />
  </div>
</template>

<script>
import { gsap } from "gsap";
import Dev from "@/components/Dev.vue";
import Navigation from "@/components/Navigation.vue";

export default {
  name: "App",
  components: {
    Navigation,
    Dev
  },
  data() {

    return {

      user: this.$userService.user,
      menuOpen: false

    };
    
  },
  watch: {
    
    $route(to, from) {
    
      this.menuOpen = false;

    }

  },
  mounted() {
    //console.log(this.user)
  },
  created() {
    
    const html = document.documentElement // returns the html tag
    html.setAttribute('lang', 'da')

  },
  methods: {

    update( e ) {

      console.log("update");
      console.log(e);

    },
    toggleMenu() {

      console.log("click");

      if ( this.menuOpen ) {

        this.closeHamburger();

      } else {

        gsap.to( this.$refs.hamburgerLineOne, .2, { y: 5 } );
        gsap.to( this.$refs.hamburgerLineTwo, .2, { y: -5, onComplete: () => {
            
          gsap.to( this.$refs.hamburgerLineOne, .2, { rotation: -45 } )
          gsap.to( this.$refs.hamburgerLineTwo, .2, { rotation: 45 } );
            
        } } );
        
      }
      /*const outsideClickListener = event => {
        const target = event.target;

        if (!target.closest("#nav") && target.id != "menu-opener") {
          this.menuOpen = false;
          removeClickListener();
        }
      };

      const removeClickListener = () => {
        document.removeEventListener("click", outsideClickListener);
      };

      document.addEventListener("click", outsideClickListener);*/

      this.menuOpen = !this.menuOpen;
    },
    closeHamburger() {

      gsap.to( [ this.$refs.hamburgerLineOne, this.$refs.hamburgerLineTwo ], .2, { rotation: 0, onComplete: () => {

        gsap.to( [ this.$refs.hamburgerLineOne, this.$refs.hamburgerLineTwo ], .2, { y: 0 } )

      } } );
    },
    closeMenu() {

      this.menuOpen = false;
      this.closeHamburger();

    }

  }

};
</script>

<style lang="scss">
@import "./main.scss";

#app {
  text-align: left;
}

.c-header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  width: 100%;
  background-color: $general-background-color;
  will-change: transform;
  transition: transform 200ms ease-in-out, color 200ms ease-in-out;

  &__inner {
    // position: relative;
    // justify-content: space-between;
    align-items: center;
    // padding-top: 1.777em;
    // padding-bottom: 1.777em;

    @include bp('max-width' #{$mobileMedium - 1}) {
      flex-direction: column-reverse;
      flex-wrap: wrap;
      padding-top: 1em;
    }
  }

  &__right {
    // flex: 1 1 auto;
    display: flex;
    align-items: center;
    
    @include bp('max-width' #{$mobileMedium - 1}) {
        justify-content: space-between;
        width: 100%;
    }
  }
}

.c-logo {
  max-width: 25%;
  height: 26px;

  @include bp('max-width' #{$mobileMedium - 1}) {
      margin-right: auto;
  }

  svg {
      height: 26px;
  }
}

$hamburgerWidth: 44px;
$lineWidth: 23px;

.c-hamburger {
  position: relative;
  width: $hamburgerWidth;
  height: 44px;
  margin-right: 0;
  margin-left: 1em;
  margin-left: auto;
  background: none;
  border: none;
  outline: none;

  @include bp('max-width' #{$mobileMedium - 1}) {
    position: absolute;
    top: 1.94em;
    right: #{($hamburgerWidth - $lineWidth) / 2 + 6px};
  }

  &__line {
    position: absolute;
    left: #{($hamburgerWidth - $lineWidth) / 2};
    width: $lineWidth;
    height: 2px;
    background-color: currentColor;

    &--one {
        top: 16px;
    }

    &--two {
        bottom: 16px;
    }
  }
}

// .hamburger-line {
//   height: 2px;
//   width: 23px;
//   background: #000;
//   position: absolute;
//   left: 10px;
//   pointer-events: none;
//   transform-origin: 12.5px 1px;
//   transition: transform 0.2s;
// }
// .hamburger-line-one {
//   top: 16px;
// }
// .hamburger-line-two {
//   bottom: 16px;
// }
// #menu-opener {
//   position: relative;
//   width: 44px;
//   height: 44px;
//   z-index: 200;
// }

// .open {
//   .hamburger-line-one {
//     transform: translateY(5px) rotate(45deg);
//   }
//   .hamburger-line-two {
//     transform: translateY(-5px) rotate(-45deg);
//   }
// }

// .router-view {
//   padding: 30px;
// }
</style>
